import React from "react";
import Modal from "react-modal";
import Select from "react-select";

export function TicketNextModal({
  isOpen,
  details,
  isRepairStatus,
  nextOption,
  onSetNextStatus,
  onConfirm,
  onCancel,
}) {
  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Set as Out of Warranty"
      className="confirm-modal"
    >
      <form onSubmit={onConfirm}>
        <div className="card">
          <div className="card-header">Ticket status</div>
          <div className="card-body">
            {details?.status?.includes("Pending Return Label to be Sent") ? (
              <div className="mb-3">
                Do you really want to sent return label link to Customer?
              </div>
            ) : (
              <div className="mb-3">Move to next progress?</div>
            )}
            {isRepairStatus && (
              <Select
                options={nextOption}
                required
                onChange={(e) => onSetNextStatus(e.value)}
                className="text-start"
              />
            )}
          </div>
          <div className="card-footer">
            <button
              type="submit"
              className="btn btn-outline-primary mr-3"
              data-testid="modal-next-btn"
            >
              Confirm
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onCancel}
              data-testid="modal-reject-btn-cancel"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
}
